import { compose, withProps, lifecycle } from 'recompose';

import Spinner from '../../common/Spinner';

export default compose(
  withProps(props => ({
    service: props.params.service,
  })),
  lifecycle({
    componentWillMount() {
      const data = {
        service: this.props.service,
      };
      if (window.location.href.indexOf('access_denied') !== -1 ||
          window.location.href.indexOf('invalid_scope') !== -1) {
        data.error = true;
      }
      window.opener.postMessage({
        type: 'authorize',
        ...data,
        params: this.props.location.query,
      }, window.opener.document.location.href);
      window.close();
    },
  }),
)(Spinner);
